import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleAddResourceGroup(
  state: State,
  { namespace, group }: Boundaries["addResourceGroup"]["success"],
): State {
  return state.map((req) =>
    req.namespace === namespace
      ? { ...req, groups: [group, ...req.groups] }
      : req,
  );
}

export { handleAddResourceGroup };
